import { formatDateForDisplayUTC } from '../../../utils/dateUtils';

/**
 * Shared formatters for the Hired Equipment screens.
 *
 * These were copy-pasted into seven components, each carrying the same comment pointing at
 * `dateUtils.formatDateForDisplayUTC` — which already existed. One copy, here.
 */

/**
 * A date-only value (expiry dates, request dates, effective dates).
 *
 * These are stored at UTC midnight, so formatting them in the viewer's local zone renders
 * 2026-12-10 as "Dec 9" anywhere west of UTC — a day early on a compliance date. `timeZone:
 * 'UTC'` is what prevents that, and is the same rule `formatDateForDisplayUTC` applies.
 */
export const shortDate = (value?: string | Date | null): string => {
  if (!value) return '—';
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    timeZone: 'UTC',
  });
};

/**
 * A real moment in time (audit timestamps). Deliberately NOT UTC-pinned: unlike the dates
 * above, these denote an instant and should read in the viewer's own zone.
 */
export const dateTime = (value?: string | Date | null): string => {
  if (!value) return '—';
  const d = value instanceof Date ? value : new Date(value);
  return Number.isNaN(d.getTime()) ? '—' : d.toLocaleString();
};

export const currency = (n: number | null | undefined): string =>
  n === null || n === undefined
    ? '—'
    : n.toLocaleString(undefined, {
        style: 'currency',
        currency: 'CAD',
        maximumFractionDigits: 2,
      });

/** Re-exported so callers that want the app-wide short form don't reach past this module. */
export { formatDateForDisplayUTC };
